import { render, staticRenderFns } from "./payment-record.vue?vue&type=template&id=37b817c4&scoped=true&"
import script from "./payment-record.vue?vue&type=script&lang=js&"
export * from "./payment-record.vue?vue&type=script&lang=js&"
import style0 from "./payment-record.vue?vue&type=style&index=0&id=37b817c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b817c4",
  null
  
)

export default component.exports